/* cosmic-zoom.js - Product image hover zoom functions */
/* These must be global because they are called from inline onmousemove handlers */

function cosmicZoom(e, element) {
  var img = element.querySelector('img');
  if (!img) return;
  var rect = element.getBoundingClientRect();
  var x = e.clientX - rect.left;
  var y = e.clientY - rect.top;
  var xPercent = (x / rect.width) * 100;
  var yPercent = (y / rect.height) * 100;
  img.style.transformOrigin = xPercent + '% ' + yPercent + '%';
  img.style.transform = 'scale(1.3)';
}

function cosmicResetZoom(element) {
  var img = element.querySelector('img');
  if (!img) return;
  img.style.transform = 'scale(1)';
  setTimeout(function() {
    img.style.transformOrigin = 'center center';
  }, 400);
}
